import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../services/login.service';
import { ForgotPassword, Login } from '../models/loginModel';
import { LoggedInUserInfo, LoggedInUserAccessDetails } from '../models/loggedInUserModel';
import { Error } from '../models/errorModel';
import { AuthService } from '../services/auth.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-forgotPassword',
  templateUrl: './forgotPassword.component.html',
  styleUrls: ['./forgotPassword.component.css'],
  standalone: false
})
export class ForgotPasswordFormComponent {
  forgotPassword: ForgotPassword = new ForgotPassword('', '',false,false,true,'','');
  user?: LoggedInUserInfo;
  errorMessage: string = '';


  constructor(private loginService: LoginService, private router: Router, private authService: AuthService) {

  }


  onSubmit() {
    this.forgotPassword.username = localStorage.getItem('UserName') ?? '';
    this.loginService.confirmForgotPassword(this.forgotPassword).subscribe((data) => {
      console.log(data);
      alert('Password Updated, Please login with new credentials');
      this.router.navigate(['/logout']);
    },
      (error) => {
        if (error instanceof HttpErrorResponse) {
          this.errorMessage = `Error: ${error.error.message}`;
        } else {
          this.errorMessage = `Error: ${error.message}`;
        }
      });
  }
}
